import React, { useState, useEffect, useRef } from 'react';
import './Header.css';

const Header = ({ activeSection }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const hamburgerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isMenuOpen && menuRef.current && !menuRef.current.contains(e.target) && hamburgerRef.current && !hamburgerRef.current.contains(e.target)) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen]);

  const navLinks = ['home', 'about', 'services', 'products', 'industries', 'why'];

  return (
    <nav id="nav" className={isScrolled ? 'scrolled' : ''}>
      <a className="nav-logo" href="#home">
        <div className="nav-logo-box">
          <img src="/assets/images/WhatsApp_Image_2026-06-11_at_14.59.14-removebg-preview.png" alt="Profibercom" />
        </div>
        <div className="nav-brand">
          <span className="nav-brand-name">PROFIBERCOM</span>
          <span className="nav-brand-sub">(Pty) Ltd</span>
        </div>
      </a>

      <ul className="nav-links">
        {navLinks.map((link) => (
          <li key={link}>
            <a href={`#${link}`} className={activeSection === link ? 'active' : ''}>{link.replace('-', ' ')}</a>
          </li>
        ))}
        <li><a href="#contact" className={`nav-cta-btn ${activeSection === 'contact' ? 'active' : ''}`}>Contact Us</a></li>
      </ul>

      <button ref={hamburgerRef} className={`hamburger ${isMenuOpen ? 'open' : ''}`} onClick={() => setIsMenuOpen(!isMenuOpen)}>
        <span></span><span></span><span></span>
      </button>

      <ul id="mobile-menu" ref={menuRef} className={isMenuOpen ? 'open' : ''}>
        {navLinks.map((link) => (
          <li key={`mobile-${link}`}>
            <a href={`#${link}`} className={activeSection === link ? 'active' : ''} onClick={() => setIsMenuOpen(false)}>{link.replace('-', ' ')}</a>
          </li>
        ))}
        <li><a href="#contact" className="nav-cta-btn-mobile" onClick={() => setIsMenuOpen(false)}>Contact Us</a></li>
      </ul>
    </nav>
  );
};

export default Header;